import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Home.scss";
import FeaturedProperties from "../../../components/home/FeaturedProperties";
import { Testimonials } from "../../../components/home/Testimonials";
import CTASection from "../../../components/home/CTASection";
import FAQSection from "@/components/property/PropertyDetails/FAQSection";

interface MenuLink {
  label: string;
  href: string;
}

interface MainLink {
  title: string;
  subLinks: MenuLink[];
}

const Home: React.FC = () => {
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);

  const mainLinks: MainLink[] = [
    {
      title: "Purchase",
      subLinks: [
        { label: "Find a Home", href: "/search" },
        { label: "Get a Pre-Approval", href: "#" },
        { label: "Buyer Portal", href: "/dashboard/customer" },
        { label: "Schedule a Tour", href: "#" },
        { label: "Find an Agent", href: "/agents" },
      ],
    },
    {
      title: "List",
      subLinks: [
        { label: "Home Valuation", href: "#" },
        { label: "What Sold Near Me", href: "#" },
        { label: "Sellers Guide", href: "#" },
        { label: "List With Us", href: "#" },
        { label: "Find an Agent", href: "/agents" },
      ],
    },
    {
      title: "Lease",
      subLinks: [
        { label: "Find a Rental", href: "/properties?type=rental" },
        { label: "Understand the Market", href: "#" },
        { label: "List your Rental", href: "#" },
        { label: "Additional Information for Renting", href: "#" },
        { label: "Find an Agent", href: "/agents" },
      ],
    },
    {
      title: "Commercial",
      subLinks: [
        { label: "Search for a Space", href: "#" },
        {
          label: "Get a Commercial Preapproval",
          href: "#",
        },
        { label: "Commercial Map", href: "#" },
        { label: "List Your Space", href: "#" },
        { label: "Find an Agent", href: "/agents" },
      ],
    },
    {
      title: "Partner",
      subLinks: [
        { label: "Affiliated Partners", href: "#" },
        { label: "Why Partner with Us", href: "#" },
        { label: "Let's Partner Together", href: "#" },
      ],
    },
  ];

  const handleMenuClick = (index: number) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  return (
    <div className="home-page">
      {/* Custom Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-wrapper">
            <div className="video-background">
              <video
                className="background-video"
                autoPlay
                loop
                muted
                playsInline
              >
                <source src="/getStarted.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="overlay"></div>
            </div>

            <div className="main-links-container">
              {mainLinks.map((mainLink, index) => (
                <React.Fragment key={index}>
                  <div
                    className={`main-link ${
                      openMenuIndex === index ? "active" : ""
                    }`}
                    onClick={() => handleMenuClick(index)}
                  >
                    <div className="main-link-content">
                      <div className="main-link-text">{mainLink.title}</div>
                      <div className="down-arrow">⌄</div>
                    </div>
                    <div
                      className={`sub-links ${
                        openMenuIndex === index ? "open" : ""
                      }`}
                    >
                      {mainLink.subLinks.map((subLink, subIndex) => (
                        <div key={subIndex} className="sub-link">
                          <Link to={subLink.href}>{subLink.label}</Link>
                        </div>
                      ))}
                    </div>
                  </div>
                  {index < mainLinks.length - 1 && <hr className="divider" />}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Featured Properties Section */}
      <FeaturedProperties />

      {/* Testimonials Section */}
      <Testimonials />



      {/* Testimonial Section */}
      <section className="testimonial-section">
        <div className="container">
          <div className="image-wrapper">
            <img
              src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800"
              alt="Professional"
              className="image"
            />
            <div className="text-overlay">
              <h4 className="subtitle">In the Words of My Clients</h4>
              <h2 className="title">Success Stories</h2>
            </div>
          </div>

          <div className="testimonial-content">
            <div className="review-card">
              <div className="stars">★★★★★</div>
              <p className="review-text">
                "Aissa was wonderful during the entire process of my home
                purchase. She sent me daily updates on the current listings and
                helped refine my choices..."
              </p>
              <div className="author-info">
                <img
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100"
                  alt="Gary Price"
                  className="author-photo"
                />
                <div>
                  <h5 className="author-name">Gary Price</h5>
                  <p className="source">View review on Google</p>
                </div>
               
              </div>
            </div>

          </div>
        </div>
      </section>

      <FAQSection/>
      {/* CTA Section */}
      <CTASection />



    </div>
  );
};

export default Home;
